import {
    APIProvider,
    GoogleMapsContext,
    Map,
    Marker,
} from '@vis.gl/react-google-maps';

import {
    useContext,
    useEffect,
    useRef
} from 'react';

export default function DriverMap({
    coords,
    marker,
    apiKey
}) {
    if (coords.length === 0) {
        // return (<></>);
        return <div style={{
            backgroundColor: '#eee',
            width: '100%',
            height: '100%',
        }}>
        </div>
    }

    const position = { lat: coords[0].coord.lat, lng: coords[0].coord.lon };

    const path = coords.map(coord => ({
        lat: coord.coord.lat,
        lng: coord.coord.lon,
    }))

    return <APIProvider apiKey={apiKey}>
        <Map defaultCenter={position} defaultZoom={14}>
            {marker && <DriverMapMarker marker={marker} />}
            <Polyline
                options={{
                    path: path,
                    strokeColor: '#ff2527',
                    strokeOpacity: 0.75,
                    strokeWeight: 2,
                }}
            />
        </Map>
    </APIProvider>;

}

function DriverMapMarker({ marker }) {
    const map = useContext(GoogleMapsContext)?.map;

    // If the marker changes and is set, put it in focus.
    useEffect(() => {
        if (!map) return

        map.panTo({ lat: marker.lat, lng: marker.lon })
    }, [marker])

    return <Marker position={{ lat: marker.lat, lng: marker.lon }} />
}

function Polyline(props) {
    // eslint-disable-next-line
    const polyline = useRef(new google.maps.Polyline()).current;
    useEffect(() => {
        polyline.setOptions(props);
    }, [props]);
    const map = useContext(GoogleMapsContext)?.map;
    useEffect(() => {
        map && polyline.setMap(map);
        return () => polyline.setMap(null);
    }, [map]);
    return null;
}
